import { useQuery } from "@tanstack/react-query";
import { getAvailableUsPhoneNumbers } from "../actions/get-us-phone-number.actions";
import { US_PHONE_NUMBER_QUERY_KEYS } from "../queries/us-phone-number.queries";

interface UseAvailableUsPhoneNumbersParams {
    areaCode?: string;
    limit?: number;
    enabled?: boolean;
}

export const useAvailableUsPhoneNumbers = ({
    areaCode = "",
    limit = 30,
    enabled = true,
}: UseAvailableUsPhoneNumbersParams = {}) => {
    const normalizedAreaCode = areaCode.trim();

    const shouldSearchByAreaCode = normalizedAreaCode.length === 3;
    const shouldFetchPopular = normalizedAreaCode.length === 0;

    return useQuery<PhoneNumber[]>({
        queryKey: [
            shouldSearchByAreaCode
                ? US_PHONE_NUMBER_QUERY_KEYS.byAreaCode(normalizedAreaCode)
                : US_PHONE_NUMBER_QUERY_KEYS.popular(),
            limit,
        ],
        queryFn: () =>
            getAvailableUsPhoneNumbers({
                areaCode: shouldSearchByAreaCode ? normalizedAreaCode : undefined,
                limit,
            }),
        enabled: enabled && (shouldFetchPopular || shouldSearchByAreaCode),
        staleTime: 0,
        retry: 1,
    });
};